import React, { useState } from "react";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { makeStyles, createStyles, useTheme } from "@material-ui/core/styles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import IconButton from "@material-ui/core/IconButton";
import qs from "query-string";
import get from "lodash/get";

import VideoTagButton from "../../components/VideoTagButton";

const useStyles = makeStyles(theme =>
  createStyles({
    expand: {
      textAlign: "center",
    },
  }),
);

const VideoTagFilteredButtons = ({
  tags = [],
  selectedNames = [],
  history,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));

  const pathname = window.location.pathname;
  const parsed = qs.parse(window.location.search);

  const [expanded, setExpanded] = useState(get(parsed, "expand_tag", false));
  const handleClickExpandButton = () => {
    setExpanded(!expanded);
  };

  const tagsLength = tags.length;
  const maxItems = matches ? 12 : 25;
  const showTags = tags.slice(0, expanded ? undefined : maxItems);
  const showExpand = tagsLength > maxItems;

  return (
    <div>
      <div>
        {showTags.map(tagName => {
          return (
            <VideoTagButton
              key={tagName}
              name={tagName}
              onClick={e => {
                const newTagNames =
                  selectedNames.indexOf(tagName) === -1
                    ? [...selectedNames, tagName]
                    : [...selectedNames.filter(name => name !== tagName)];
                const newLocation = {
                  pathname,
                  search: `${qs.stringify({
                    ...parsed,
                    tag_name: newTagNames,
                  })}`,
                };
                history.push(newLocation);
              }}
              selected={selectedNames.indexOf(tagName) !== -1}
            />
          );
        })}
      </div>
      {showExpand && (
        <div className={classes.expand}>
          <IconButton aria-label='expand' onClick={handleClickExpandButton}>
            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </div>
      )}
    </div>
  );
};

VideoTagFilteredButtons.defaultProps = {};

VideoTagFilteredButtons.propsTypes = {};

export default withRouter(VideoTagFilteredButtons);
